<button
  *ngIf="!isTablet"
  class="btn-download"
  (click)="onButtonClick()"
>
  <span class="icon-download mr-2"></span>
  <!-- <span *ngIf="!progress" class="pi pi-download"></span> -->
  Download IC Voting Details
</button>
